/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _region = _interopRequireDefault(require("../region"));
require("./Region.static");
require("./Region.proto");
var _computeAlignRegion = _interopRequireDefault(require("./computeAlignRegion"));
_region.default.alignRegions = function (sourceRegion, targetRegion, positions, config) {
  var result = (0, _computeAlignRegion.default)(sourceRegion, targetRegion, positions, config);
  var alignedRegion = result.region;
  if (!alignedRegion.equals(sourceRegion)) {
    sourceRegion.setRegion(alignedRegion);
  }
  return result.position;
};
_region.default.prototype.alignTo = function (target, positions, config) {
  config = config || {};
  var sourceRegion = this;
  var targetRegion = _region.default.from(target);
  var result = (0, _computeAlignRegion.default)(sourceRegion, targetRegion, positions, config);
  var resultRegion = result.region;
  if (!resultRegion.equalsSize(sourceRegion)) {
    this.setSize(resultRegion.getSize());
  }
  if (!resultRegion.equalsPosition(sourceRegion)) {
    this.setPosition(resultRegion.getPosition(), {
      absolute: !!config.absolute
    });
  }
  return result.position;
};
var _default = _region.default;
exports.default = _default;